/* global __WEB__ */

import map from 'lodash/map';
import without from 'lodash/without';
import throttler from './throttler';
import {
    socketConnect,
    socketSubscribe,
    socketUnsubscribe,
} from '../actions/socket';

class TickerSubscriber {
    constructor() {
        // Keep a reference to each symbol we subscribe to by channel-id
        //  [channel-id]: [symbol]
        this.channels = {};

        this.subscribingSymbols = [];

        this.pending = [];

        this.hasSent = false;
    }

    start(dispatch, action, url) {
        this.url = url;
        this.dispatch = dispatch;

        // Create a dispatch function which is throttled, to be called maximun once per 750 ms
        // per ticker.
        this.dispatchAction = throttler((...args) => {
            dispatch(action(...args));
        }, 750);

        this.connect();
    }

    connect() {
        if (!window.WebSocket) {
            return;
        }

        this.dispatch(socketConnect({ url: this.url }));

        if (this.pending.length > 0) {
            for (let i = 0; this.pending.length > i; i++) {
                this.subscribe(this.pending[i].channel, this.pending[i].symbol);
            }

            this.pending = [];
        }
    }

    onMessage(data) {
        try {
            if (typeof data.type === 'undefined') {
                return;
            }

            if (data.type === 'new' || data.type === 'update') {
                this.dispatchAction(data.key, data.values);
            }
        } catch (e) {
            // ignore error
        }
    }

    subscribe(channel, symbol) {
        // Avoid subscribing if we are already subscribing to it
        if (this.subscribingSymbols.indexOf(symbol) > -1) {
            return null;
        }

        const query = map({
            type: 'table',
            itemSector: symbol,
            columns: [
                // @TODO: These columns are currenctly unused
                // 'ITEM', '_DELAY', 'sector_close_time', 'sector_open_time'

                // @TODO: These columns rarely update and don't need to be streamed
                // 'BASE_Y', 'VOLATILITY_3M', 'BETA_1Y', 'TOTAL_SHARES', 'TARGET_PRICE_MEDIAN',
                // 'RECOM_BUY', 'RECOM_OVERWEIGHT', 'RECOM_HOLD', 'RECOM_UNDERWEIGHT', 'RECOM_SELL',
                // 'MEDIAN_EPS_YP1', 'MEDIAN_SALES_YP1', 'MEDIAN_NET_ASSETS_YP1', 'P_E_YP1',
                // 'MARKET_CAP_SALES_YP1', 'EBITDA_MEDIAN_YP1', 'ENTERPRISE_VALUE_YP1',
                // 'MEDIAN_EPS_Y', 'MEDIAN_SALES_Y', 'MEDIAN_NET_ASSETS_Y', 'P_E_Y',
                // 'MARKET_CAP_SALES_Y', 'EBITDA_MEDIAN_Y', 'ENTERPRISE_VALUE_Y', 'MEDIAN_EPS_YM1',
                // 'MEDIAN_SALES_YM1', 'MEDIAN_NET_ASSETS_YM1', 'P_E_YM1', 'MARKET_CAP_SALES_YM1',
                // 'EBITDA_MEDIAN_YM1', 'ENTERPRISE_VALUE_YM1', 'ISIN', 'GICS_CODE',

                'LONG_NAME', 'SECURITYNAME', 'LAST', 'LASTNZ', 'CHANGE', 'CHANGE_PCT', 'SECTOR',
                'CLOSE_BEGIN_1DAY', 'TIME', 'LOW', 'HIGH', 'OPEN', 'CURRENCY', 'TURNOVER', 'VOLUME',
                'MARKET_CAP_ROUNDED', 'CLOSE_CA_BEGIN_1DAY', 'TOTAL_NUMBER_OF_SHARES', 'TURNOVER',
                'TURNOVER_MAX', 'VOLUME', 'CHANGE_7DAYS', 'CHANGE_7DAYS_PCT', 'CHANGE_MONTH',
                'CHANGE_MONTH_PCT', 'CHANGE_YEAR', 'CHANGE_YEAR_PCT', 'CHANGE_1YEAR',
                'CHANGE_1YEAR_PCT', 'CHANGE_5YEARS', 'CHANGE_5YEARS_PCT',
            ].join(','),
            channel,
        }, (value, key) => `${key}=${value}`).join('&');

        if (typeof this.dispatch === 'function') {
            // Store a reference to the channel.
            this.channels[channel] = symbol;
            this.subscribingSymbols.push(symbol);

            this.dispatch(socketSubscribe({
                channel,
                query,
                onMessage: this.onMessage.bind(this),
            }));
        } else {
            // add to pending subscriptions
            this.pending.push({ channel, symbol });
        }

        return channel;
    }

    unsubscribe(channel) {
        if (!channel) {
            return;
        }

        // Clean up, so we can subscribe to the symbol again
        if (this.channels.hasOwnProperty(channel)) {
            const symbol = this.channels[channel];
            this.symbols = without(this.symbols, symbol);

            const subIndex = this.subscribingSymbols.indexOf(symbol);
            if (subIndex > -1) {
                delete this.subscribingSymbols[subIndex];
            }

            delete this.channels[channel];
        }

        this.dispatch(socketUnsubscribe({ channel }));
    }
}

export default __WEB__ ? new TickerSubscriber() : null;



/** WEBPACK FOOTER **
 ** /src/shared/service/tickersubscriber.js
 **/